import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryDownloadListDetailService = (data: any) => {
  return axiosInstance
    .get(
      `${ENDPOINTS.ADMIN.OPERATION_HISTORY.EXTERNAL_DELIVERY.READ_LIST}?${data}`,
    )
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
